<template>
  <b-card-code title="" no-body>
    <b-card-body>
      <h3>Total Skp : {{ rows }}</h3>
    </b-card-body>

    <b-card-body>
      <b-row>
        <b-col md="2" xl="2" class="mb-1">
          <!-- email -->
          <b-form-group label="Status Verifikasi" label-for="skp_verified">
            <validation-provider #default="{ errors }" name="skp_verified">
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <v-select
                  id="skp_verified"
                  v-model="filter.skp_verified"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="skpVerify"
                  placeholder="status verifikasi?.."
                />
              </b-input-group>
              <b>notes: true(terverifikasi) false(tidak terverifikasi)</b>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- nama_lengkap -->
          <b-form-group label="Jumlah" label-for="skp_jumlah">
            <validation-provider #default="{ errors }" name="skp_jumlah">
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="basicInput"
                  placeholder="Search jumlah SKP"
                  v-model="filter.skp_jumlah"
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- nama_lengkap -->
          <b-form-group label="Nama Dokter" label-for="orang_nama_lengkap">
            <validation-provider
              #default="{ errors }"
              name="orang_nama_lengkap"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="orang_nama_lengkap"
                  placeholder="Search jumlah SKP"
                  v-model="filter.orang_nama_lengkap"
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- npa_id -->
          <b-form-group label="Nomor SKP" label-for="skp_no">
            <validation-provider #default="{ errors }" name="skp_no">
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="basicInput"
                  placeholder="Search nomor SKP"
                  v-model="filter.skp_no"
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- nama_lengkap -->
          <b-form-group label="Tanggal" label-for="created_at">
            <validation-provider #default="{ errors }" name="created_at">
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="created_at"
                  placeholder="Search jumlah SKP"
                  v-model="filter.created_at"
                  type="date"
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="2" md="3" class="mb-25">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-primary"
            class="mt-0 mt-md-2"
            @click="refreshPage()"
          >
            <feather-icon icon="SearchIcon" class="mr-25" />
            <span>Search</span>
          </b-button>
        </b-col>
      </b-row>

      <b-button-toolbar
        class="d-flex justify-content-between flex-wrap pt-0"
        aria-label="Toolbar with button groups and dropdown menu"
      >
        <!-- group -->
        <b-button-group>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="refreshPage()"
          >
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </b-button-group>
      </b-button-toolbar>
    </b-card-body>

    <!-- table -->
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      class="mb-0"
      @row-selected="onRowSelected"
    >
      <template #cell(document)="data">
        <a :href="data.item.document" v-if="data.item.document" target="_blank"
          >Open</a
        >
      </template>
      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(action)="data">
        <b-dropdown variant="link" no-caret toggle-class="p-0" right>
          <template #button-content>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </template>

          <b-dropdown-item @click="modalUpdateSkp(data.item)">
            <feather-icon icon="CheckSquareIcon" size="16" />
            <span class="align-middle ml-50">Edit</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <div></div>
      <!--pagination -->
      <div class="demo-inline-spacing pt-0">
        <b-pagination
          v-model="currentPage"
          hide-goto-end-buttons
          :total-rows="rows"
          :per-page="perPage"
        />
      </div>
    </b-card-body>
    <b-modal id="modal-export" hide-footer>
      <template #modal-title> Input Email Tujuan </template>
      <div class="d-block text-center">
        <p>
          Data yang akan diexport lebih dari <b>500</b> baris dan akan dikirim
          via email, Silahkan masukkan email anda!
        </p>
      </div>
      <b-form-group>
        <label for="email">Email:</label>
        <b-form-input
          id="email"
          type="email"
          placeholder="Email Address"
          v-model="email"
        />
      </b-form-group>
      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="exportData()"
      >
        <feather-icon icon="DownloadCloudIcon" /> Export
      </b-button>
    </b-modal>

    <b-modal
      id="modal-update-skp"
      title="Edit Skp"
      cancel-variant="outline-secondary"
      hide-footer
    >
      <validation-observer ref="validateBeforeEditSKP">
        <b-form @submit.prevent>
          <b-form-input
            id="id_galeri"
            v-model="updateSkp.id"
            placeholder="Judul Galeri"
            hidden
          />
          <p>
            <b>File SKP: </b>
            <a :href="updateSkp.skp_file" target="_blank">Show</a>
          </p>
          <b-form-group label="jenis" label-for="jenis_skp ">
            <validation-provider
              #default="{ errors }"
              name="Jenis SKP"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="jenis_skp"
                  v-model="updateSkp.skpjeni_id"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Jenis SKP..."
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="nomor_skp" label-for="nomor_skp ">
            <validation-provider
              #default="{ errors }"
              name="Nomor SKP"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="nomor_skp"
                  v-model="updateSkp.skp_no"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Nomor SKP..."
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="jumlah" label-for="jumlah_skp ">
            <validation-provider
              #default="{ errors }"
              name="Nomor SKP"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="jumlah_skp"
                  v-model="updateSkp.skp_jumlah"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Jumlah SKP..."
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label="terferifikasi" label-for="terferifikasi">
            <validation-provider
              #default="{ errors }"
              name="Verifikasi SKP"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <v-select
                  id="terferifikasi"
                  v-model="updateSkp.skp_verified"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :state="errors.length > 0 ? false : null"
                  :options="skpVerify"
                  placeholder="verifikasi SKP.."
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <br />
          <b-button
            variant="primary"
            type="submit"
            block
            :disabled="invalid"
            @click="validateEditSKP"
          >
            Update SKP
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

import {
  BTable,
  BButton,
  BFormGroup,
  BAvatar,
  BBadge,
  BCardBody,
  BPagination,
  BFormTextarea,
  BFormFile,
  BButtonToolbar,
  BButtonGroup,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BRow,
  BCol,
  BModal,
} from "bootstrap-vue";
import API from "@/api";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCardCode,
    BTable,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
    BPagination,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BFormFile,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BModal,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      currentPage: 1,
      rows: 0,
      perPage: 20,
      modes: ["multi", "single", "range"],
      fields: [
        { key: "id", label: "Id" },
        // "orang_id",
        { key: "orang_id.orang_nama_lengkap", label: "Anggota" },
        "skpjeni_id",
        "skp_no",
        "skp_jumlah",
        { key: "skp_verified", label: "Status Verifikasi" },
        { key: "created_at", label: "Tanggal Buat" },
        { key: "updated_at", label: "Tanggal Ubah" },
        "action",
      ],
      items: [],
      status: [
        {
          0: "Register",
          1: "Verify",
          2: "Can't find",
          3: "Input wrong data",
        },
        {
          0: "light-primary",
          1: "light-success",
          2: "light-warning",
          3: "light-warning",
          5: "light-info",
        },
      ],
      selectMode: "multi",
      selected: [],

      search: null,
      updateSkp: {},
      skpVerify: ["true", "false"],
      filter: {
        skp_verified: "",
        skp_jumlah: "",
        skp_no: "",
      },
    };
  },
  methods: {
    validateEditSKP() {
      this.$refs.validateBeforeEditSKP.validate().then((success) => {
        if (success) {
          this.updateDataSkp();
        }
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    refreshPage() {
      if (this.currentPage == 1) {
        this.getSkp();
      } else {
        this.currentPage = 1;
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      }
      return `${files.length} files selected`;
    },

    modalUpdateSkp(item) {
      this.updateSkp = item;
      this.$bvModal.show("modal-update-skp");
    },

    async getSkp() {
      try {
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", true);

        const form = {
          limit: this.perPage,
          page: this.currentPage,
          search: this.search,
          ...this.filter,
        };
        const { data } = await API.skp.list(form);
        this.data_table = data;
        this.items = data.data;
        this.rows = data.total;
        this.handleMsgSuccess("Berhasil tampilkan data skp");
      } catch (error) {
        console.log(error);
        this.handleMsgErrors(error, "Terjadi kesalahan silahkan coba lagi!");
      } finally {
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", false);
      }
    },

    async updateDataSkp() {
      try {
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", true);

        var ids = this.updateSkp.id;

        let body = {
          skpjeni_id: this.updateSkp.skpjeni_id,
          skp_no: this.updateSkp.skp_no,
          skp_jumlah: this.updateSkp.skp_jumlah,
          skp_verified: this.updateSkp.skp_verified,
        };
        await API.skp.updateData(ids, body);
        this.refreshPage();
        this.handleMsgSuccess("Berhasil Update skp");
      } catch (error) {
        console.log(error);
        this.handleMsgErrors(error, "gagal update skp");
      } finally {
        this.$bvModal.hide("modal-update-skp");
        this.clearSelected();
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", false);
      }
    },
  },
  mounted() {
    this.getSkp();
  },
  watch: {
    currentPage() {
      this.getSkp();
    },
  },
};
</script>

<style lang="scss">
.b-table-selectable {
  .feather {
    font-size: 1.3rem;
  }
}
</style>
